import { Box, Stack, SxProps } from '@mui/material';
import { AnimatedBackgroundRotatingCircle } from './AnimatedBackgroundRotatingCircle';

interface AnimatedBackgroundContainerProps {
  children: React.ReactNode;
  sxProps?: SxProps;
}

export const AnimatedBackgroundContainer = ({
  children,
  sxProps = {},
}: AnimatedBackgroundContainerProps) => {
  return (
    <Stack
      height="100vh"
      width="100vw"
      alignItems="center"
      justifyContent="center"
      py={8}
      px={16}
      spacing={4}
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        overflowX: 'hidden',
        overflowY: 'auto',
        backgroundColor: 'background.paper',
        ...sxProps,
      }}
    >
      <Box
        component={AnimatedBackgroundRotatingCircle}
        sx={{
          backgroundColor: '#d220ff',
          transform:
            'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(93.5964deg) skew(0deg, 0deg)',
          willChange: 'transform',
          left: -90,
          bottom: -50,
        }}
      />
      <Box
        component={AnimatedBackgroundRotatingCircle}
        sx={{
          backgroundColor: '#1766ff',
          transform:
            'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(47.0988deg) skew(0deg, 0deg)',
          right: -90,
          top: -50,
        }}
      />
      <Stack
        py={6}
        px={16}
        height="100vh"
        width="100vw"
        zIndex={1}
        spacing={4}
        margin="0 !important"
      >
        {children}
      </Stack>
    </Stack>
  );
};
